export const SET_CATEGORIES = 'SET_CATEGORIES';

export const setCategories = (value) => {
    return {
        type: SET_CATEGORIES,
        payload: value,
    };
};